import { z } from 'zod'
import { CategoryEnum, CreateEntryInput, FeelingEnum, UpdateEntryCategoryInput, UpdateEntryFeelingInput, UpsertDailyDiaryInput, UserCategoryInput, UserFeelingInput } from './graphql'

type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export const CategoryEnumSchema = z.nativeEnum(CategoryEnum);

export const FeelingEnumSchema = z.nativeEnum(FeelingEnum);

export function CreateEntryInputSchema(): z.ZodObject<Properties<CreateEntryInput>> {
  return z.object({
    latitude: z.number().nullish(),
    longitude: z.number().nullish()
  })
}

export function UpdateEntryCategoryInputSchema(): z.ZodObject<Properties<UpdateEntryCategoryInput>> {
  return z.object({
    categoryKey: CategoryEnumSchema
  })
}

export function UpdateEntryFeelingInputSchema(): z.ZodObject<Properties<UpdateEntryFeelingInput>> {
  return z.object({
    feelingKey: FeelingEnumSchema
  })
}

export function UpsertDailyDiaryInputSchema(): z.ZodObject<Properties<UpsertDailyDiaryInput>> {
  return z.object({
    body: z.string()
  })
}

export function UserCategoryInputSchema(): z.ZodObject<Properties<UserCategoryInput>> {
  return z.object({
    color: z.string(),
    name: z.string()
  })
}

export function UserFeelingInputSchema(): z.ZodObject<Properties<UserFeelingInput>> {
  return z.object({
    color: z.string(),
    name: z.string()
  })
}
